import {IBackgroundObject} from "../../structural";

export type BaseLayoutSettingsType = {
    padding?: string;
    background?: IBackgroundObject;
    panelClass?: string
}
